export default __webpack_public_path__ + "static/media/isso_updated.05e0f8b5.svg";